module.exports = __webpack_public_path__ + "img/small_t1_fine_nut.prt.4fbfc0ed.jpg";